'use strict';

/* globals config, $, utils, ajaxify, app */

require([config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js'], function (Vue) {
	var internals = {};

	Vue.component('course-files-panel', {
		props: ['initData'],
		data: function () {
			return {
				files: this.initData.files,
				label: this.initData.translations.uploadFile,
				icon: 'fa fa-file-text-o',
				filename: '',
				fileUploadPlaceholder: 'file name',
			};
		},
		mounted: function () {

		},
		methods: {
			removeFile: function (file) {
				var index = this.files.indexOf(file);

				if (index > -1) {
					this.files.splice(index, 1);
				}
			},
			onUploadSuccess: function (file) {
				this.files.push({ name: this.filename, url: file.url });

				this.saveFilePermissions(file.url);

				this.filename = '';
			},
		},
		template:
		'<div>' +
			'<ul class="list-group">' +
				'<li class="list-group-item" v-for="(file, index) in files">' +
					'<div class="row">' +
						'<div class="col-sm-1" style="padding-top: 9px">' +
							'<a :href="file.url" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i> open</a>' +				
						'</div>' +
						'<div class="col-sm-7">' +
							'<input type="text" class="form-control" v-model="file.name" />' +
						'</div>' +
						'<div class="col-sm-4" style="padding-top: 9px"><button v-on:click="removeFile(file)" type="button" class="btn btn-xs btn-danger pull-right">Remove</button></div>' +
					'</div>' +
				'<li>' +
				'<li class="list-group-item">' +
					'<div class="input-group">' +
						'<input type="text" class="form-control" :placeholder="fileUploadPlaceholder" v-model="filename" />' +
						'<span class="input-group-btn">' +
							'<upload-component :label="label" :icon="icon" :onUploadSuccess="onUploadSuccess"></upload-component>' +
						'</span>' +
					'</div>' +
				'</li>' +
			'</ul>' +
		'</div>',
	});
});
